import React, { useState } from "react";
import { Segmented } from "antd";
import dayjs from "dayjs";
import PlatemapInstrument from "./PlatemapInstrument";
import PlatemapSequence from "./PlatemapSequence";
import "./Platemap.css";

const Platemap = () => {
  const [selectedInstrument, setSelectedInstrument] = useState(null);
  const [historyDate, setHistoryDate] = useState(null);
  const [view, setView] = useState("Pending");

  const handleSelectInstrument = (item) => {
    if (selectedInstrument && item.id === selectedInstrument.id) {
      setSelectedInstrument(null);
    } else {
      setSelectedInstrument(item);
    }
  };

  const handleSetView = (value) => {
    setView(value);
    setHistoryDate(value === "Pending" ? null : dayjs(new Date()));
  };

  return (
    <div>
      <Segmented
        block
        className="Platemap__Segmented"
        options={[
          { value: "Pending", label: "Pending" },
          { value: "History", label: "History" },
        ]}
        onChange={handleSetView}
      />
      <div className="PlatemapContainer AntdFontFamily">
        <PlatemapInstrument handleSelectInstrument={handleSelectInstrument} view={view} historyDate={historyDate} setHistoryDate={setHistoryDate} />
        <PlatemapSequence selectedInstrument={selectedInstrument} view={view} historyDate={historyDate} />
      </div>
    </div>
  );
};

export default Platemap;
